module.exports = __webpack_public_path__ + "media/images/fuda02-ee92d0203b53d94079553a44a4270bef.jpg";